import { render } from "./ReviewScreen.vue?vue&type=template&id=1b1c7b39&scoped=true&ts=true"
import script from "./ReviewScreen.vue?vue&type=script&lang=ts"
export * from "./ReviewScreen.vue?vue&type=script&lang=ts"

import "./ReviewScreen.vue?vue&type=style&index=0&id=1b1c7b39&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1c7b39"]])

export default __exports__